import React from "react";
import { ContentBuilderType } from "../../../constants/types/acf/content-builder-types";
import { scrollToElementIdPosition, titleToUrl } from "../../../utils";
import { List, OnThisPageOuter } from "./styled";

export const OnThisPage = (props: {
    content?: ContentBuilderType;
    showLocalServicesAnchor?: boolean;
}) => {
    const blocks = props.content?.[0].content_builder || [];

    return (
        <OnThisPageOuter>
            <h2>On this page</h2>
            <List>
                {blocks.map((block, index) => (
                    <li key={index}>
                        <a href={`#${titleToUrl(block.section_title)}`} onClick={(e) => {
                            e.preventDefault()
                            scrollToElementIdPosition(`#${titleToUrl(block.section_title)}`)
                        }}>{block.section_title}</a>
                    </li>
                ))}
                <>
                {props.showLocalServicesAnchor && (
                    <li>
                        <a href="#services" onClick={(e) => {
                            e.preventDefault() 
                            scrollToElementIdPosition("#services")
                        }}>Services</a>
                    </li>
                )}
                </>
            </List>
        </OnThisPageOuter>
    );
};
